import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useAppVersion } from '~/hooks/useAppVersion';
import { reloadWithFreshAssets } from '~/utils/session';

/**
 * Franja discreta que aparece cuando se ha publicado una versión nueva.
 *
 * No recarga por su cuenta a propósito: si alguien está rellenando una
 * reserva, perdería lo escrito. Se le ofrece actualizar cuando le venga bien.
 */
const AvisoNuevaVersion = () => {
  const hayVersionNueva = useAppVersion();
  const [actualizando, setActualizando] = useState(false);

  if (!hayVersionNueva) return null;

  return (
    <Box
      position='fixed'
      bottom={5}
      left='50%'
      transform='translateX(-50%)'
      zIndex={2000}
      bg='gray.800'
      color='white'
      px={5}
      py={3}
      borderRadius='full'
      boxShadow='lg'
    >
      <HStack spacing={4}>
        <Text fontSize='sm'>Hay una versión nueva de la aplicación.</Text>
        <Button
          size='sm'
          colorScheme='blue'
          isLoading={actualizando}
          loadingText='Actualizando'
          onClick={async () => {
            setActualizando(true);
            await reloadWithFreshAssets();
          }}
        >
          Actualizar
        </Button>
      </HStack>
    </Box>
  );
};

export default AvisoNuevaVersion;
